module.exports = __webpack_public_path__ + "static/media/Lynktrac.89f66502.png";